module.exports = __webpack_public_path__ + "static/useofforce-2d817aeb16708ae1c162410f277eb5e1.png";